const style = document.createElement('style');
style.textContent = `
  button.chat-toggle {
    width: 48px !important;
    height: 48px !important;
  }
  button.chat-toggle svg {
    width: 38px !important;
    height: 38px !important;
  }
  button.chat-toggle .chat-notification {
    width: 18px !important;
    height: 18px !important;
    line-height: 18px !important;
    font-size: 11px !important;
    top: 17px !important;
    right: 6px !important;
  }
  .chat-app--close-button {
    width: 48px !important;
    height: 48px !important;
  }
  .chat-app--close-button svg {
    width: 24px !important;
    height: 24px !important;
  }
`;

const styleOpacity = document.createElement('style');
styleOpacity.textContent = `
  #shopify-chat inbox-online-store-chat {
    opacity: 1 !important;
  }
`;

let count = 0;
const maxRuns = 50;
const interval = setInterval(() => {
  const chatInstance = document.querySelector('#shopify-chat inbox-online-store-chat');
  if (chatInstance) {
    const shadow = chatInstance.shadowRoot;
    shadow.appendChild(style);
    document.head.appendChild(styleOpacity);
    clearInterval(interval);
  }
  if (count >= maxRuns) clearInterval(interval);
  count += 1;
}, 250);
